import { useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';

export const useScrollWatcher = (callback, { deps = [], interval = 100 }) => {
    let scrollListener = null;

    let position = useRef(0);

    const checkScrollPosition = () => {
        callback(position.current);
        position.current = window.pageYOffset;
    };

    useEffect(() => {
        const handleScroll = () => {
            checkScrollPosition();
        };

        const debouncedHandleScroll = debounce(handleScroll, interval);

        scrollListener = window.addEventListener(
            'scroll',
            debouncedHandleScroll,
        );

        return window.removeEventListener('scroll', scrollListener);
    }, deps);
};
